import React, { useMemo, useState } from 'react';
import { Search, Users, Layers, FileText, Wallet, Download, X, MoreVertical, ExternalLink } from 'lucide-react';
import { AppBadge } from '../components/base/AppBadge';
// Mock Data
const MOCK_SUPPLIERS = [{
  id: '1',
  name: 'TechCorp Solutions',
  email: 'admin@techcorp.it',
  type: 'Sviluppo',
  servicesCount: 4,
  contractStatus: 'Attivo',
  monthlySpend: 4500
}, {
  id: '2',
  name: 'CloudSys Italia',
  email: 'billing@cloudsys.it',
  type: 'Cloud',
  servicesCount: 8,
  contractStatus: 'In rinnovo',
  monthlySpend: 8200
}, {
  id: '3',
  name: 'SecurIT Partners',
  email: 'info@securit.com',
  type: 'Sicurezza',
  servicesCount: 2,
  contractStatus: 'Attivo',
  monthlySpend: 2100
}, {
  id: '4',
  name: 'DataConsulting SPA',
  email: 'contact@dataconsulting.it',
  type: 'Consulenza',
  servicesCount: 5,
  contractStatus: 'Scaduto',
  monthlySpend: 0
}, {
  id: '5',
  name: 'InfraNet Group',
  email: 'support@infranet.it',
  type: 'Infrastruttura',
  servicesCount: 4,
  contractStatus: 'Attivo',
  monthlySpend: 3650
}];
export function FornitoriPage() {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedType, setSelectedType] = useState('Tutti');
  // Filter logic
  const filteredSuppliers = useMemo(() => {
    return MOCK_SUPPLIERS.filter(supplier => {
      if (searchQuery && !supplier.name.toLowerCase().includes(searchQuery.toLowerCase()) && !supplier.email.toLowerCase().includes(searchQuery.toLowerCase())) {
        return false;
      }
      if (selectedType !== 'Tutti' && supplier.type !== selectedType) {
        return false;
      }
      return true;
    });
  }, [searchQuery, selectedType]);
  const handleResetFilters = () => {
    setSearchQuery('');
    setSelectedType('Tutti');
  };
  const getTypeBadgeVariant = (type: string) => {
    switch (type) {
      case 'Sviluppo':
        return 'blue';
      case 'Cloud':
        return 'primary';
      case 'Sicurezza':
        return 'red';
      case 'Consulenza':
        return 'amber';
      case 'Infrastruttura':
        return 'default';
      default:
        return 'default';
    }
  };
  const getContractBadgeVariant = (status: string) => {
    switch (status) {
      case 'Attivo':
        return 'success';
      case 'In rinnovo':
        return 'warning';
      case 'Scaduto':
        return 'danger';
      default:
        return 'default';
    }
  };
  return <div className="min-h-screen bg-[#F4F6F8] p-4 md:p-8" data-id="element-2593">
      {/* Header Section */}
      <div className="mb-8" data-id="element-2594">
        <h1 className="text-[28px] md:text-[32px] font-semibold text-[#2a3a54] tracking-tight" data-id="element-2595">
          Fornitori
        </h1>
      </div>

      {/* KPI Cards Row */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-id="element-2596">
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm flex flex-col" data-id="element-2597">
          <h3 className="text-[13px] font-medium text-gray-500 mb-3" data-id="element-2598">
            Totale Fornitori
          </h3>
          <div className="flex items-baseline gap-2 mt-auto" data-id="element-2599">
            <span className="text-[28px] font-bold text-[#1A202C]" data-id="element-2600">14</span>
          </div>
        </div>

        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm flex flex-col" data-id="element-2601">
          <h3 className="text-[13px] font-medium text-gray-500 mb-3" data-id="element-2602">
            Servizi Esternalizzati
          </h3>
          <div className="flex items-baseline gap-2 mt-auto" data-id="element-2603">
            <span className="text-[28px] font-bold text-[#1A202C]" data-id="element-2604">23</span>
          </div>
        </div>

        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm flex flex-col" data-id="element-2605">
          <h3 className="text-[13px] font-medium text-gray-500 mb-3" data-id="element-2606">
            Contratti Attivi
          </h3>
          <div className="flex items-baseline gap-2 mt-auto" data-id="element-2607">
            <span className="text-[28px] font-bold text-[#1A202C]" data-id="element-2608">11</span>
          </div>
        </div>

        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm flex flex-col" data-id="element-2609">
          <h3 className="text-[13px] font-medium text-gray-500 mb-3" data-id="element-2610">
            Spesa Mensile
          </h3>
          <div className="flex items-baseline gap-2 mt-auto" data-id="element-2611">
            <span className="text-[28px] font-bold text-[#1A202C]" data-id="element-2612">
              €18.450
            </span>
          </div>
        </div>
      </div>

      {/* Filter Bar */}
      <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm flex flex-col md:flex-row gap-4 items-center justify-between mb-6" data-id="element-2613">
        <div className="flex flex-1 items-center gap-4 w-full md:w-auto" data-id="element-2614">
          <div className="relative flex-1 md:max-w-xs" data-id="element-2615">
            <Search className="w-4 h-4 text-gray-400 absolute left-3 top-3" data-id="element-2616" />
            <input type="text" placeholder="Cerca fornitore..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full bg-gray-50 border border-gray-200 text-[#1A202C] pl-9 pr-4 py-2.5 rounded-lg text-[13px] placeholder-gray-400 focus:outline-none focus:border-[#00B4D8] focus:ring-1 focus:ring-[#00B4D8]" data-id="element-2617" />
          </div>

          <select value={selectedType} onChange={e => setSelectedType(e.target.value)} className="bg-gray-50 border border-gray-200 text-[#1A202C] px-4 py-2.5 rounded-lg text-[13px] focus:outline-none focus:border-[#00B4D8] focus:ring-1 focus:ring-[#00B4D8]" data-id="element-2618">
            <option value="Tutti" data-id="element-2619">Tutti i tipi</option>
            <option value="Consulenza" data-id="element-2620">Consulenza</option>
            <option value="Sviluppo" data-id="element-2621">Sviluppo</option>
            <option value="Infrastruttura" data-id="element-2622">Infrastruttura</option>
            <option value="Cloud" data-id="element-2623">Cloud</option>
            <option value="Sicurezza" data-id="element-2624">Sicurezza</option>
          </select>
        </div>

        <div className="flex gap-2" data-id="element-2625">
          <button title="Export CSV" className="p-2 text-gray-600 hover:text-[#1A202C] hover:bg-gray-100 rounded-lg transition-all" data-id="element-2626">
            <Download className="w-4 h-4" data-id="element-2627" />
          </button>
          <button onClick={handleResetFilters} title="Reset Filters" className="p-2 text-gray-600 hover:text-[#1A202C] hover:bg-gray-100 rounded-lg transition-all" data-id="element-2628">
            <X className="w-4 h-4" data-id="element-2629" />
          </button>
        </div>
      </div>

      {/* Suppliers Table */}
      <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden" data-id="element-2630">
        <div className="px-6 py-5 border-b border-gray-100 flex items-center justify-between" data-id="element-2631">
          <h2 className="text-[16px] font-semibold text-[#2a3a54]" data-id="element-2632">
            Elenco Fornitori
          </h2>
          <button className="text-[13px] text-gray-500 font-medium hover:text-[#2a3a54] transition-colors" data-id="element-2633">
            Esporta Report
          </button>
        </div>

        {/* Desktop Table */}
        <div className="hidden md:block overflow-x-auto" data-id="element-2634">
          <table className="w-full" data-id="element-2635">
            <thead className="bg-gray-50/50 border-b border-gray-100" data-id="element-2636">
              <tr data-id="element-2637">
                <th className="px-6 py-3 text-left text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2638">
                  Fornitore
                </th>
                <th className="px-6 py-3 text-left text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2639">
                  Tipo
                </th>
                <th className="px-6 py-3 text-left text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2640">
                  Servizi
                </th>
                <th className="px-6 py-3 text-left text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2641">
                  Spesa Mensile
                </th>
                <th className="px-6 py-3 text-left text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2642">
                  Contratto
                </th>
                <th className="px-6 py-3 text-right text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2643">
                  Azioni
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-2644">
              {filteredSuppliers.map(supplier => <tr key={supplier.id} className="hover:bg-gray-50/50 transition-colors" data-id="element-2645">
                  <td className="px-6 py-4" data-id="element-2646">
                    <div data-id="element-2647">
                      <p className="text-[13px] font-medium text-[#2a3a54]" data-id="element-2648">
                        {supplier.name}
                      </p>
                      <p className="text-[13px] text-gray-500" data-id="element-2649">
                        {supplier.email}
                      </p>
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-2650">
                    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-medium border ${supplier.type === 'Sviluppo' ? 'bg-blue-50 text-blue-700 border-blue-100' : supplier.type === 'Cloud' ? 'bg-indigo-50 text-indigo-700 border-indigo-100' : supplier.type === 'Sicurezza' ? 'bg-red-50 text-red-700 border-red-100' : supplier.type === 'Consulenza' ? 'bg-amber-50 text-amber-700 border-amber-100' : 'bg-gray-50 text-gray-700 border-gray-100'}`} data-id="element-2651">
                      {supplier.type}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-2652">
                    <span className="text-[13px] text-gray-500" data-id="element-2653">
                      {supplier.servicesCount}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-2654">
                    <span className="text-[13px] text-gray-500" data-id="element-2655">
                      €{supplier.monthlySpend.toLocaleString()}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-2656">
                    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-medium border ${supplier.contractStatus === 'Attivo' ? 'bg-emerald-50 text-emerald-700 border-emerald-100' : supplier.contractStatus === 'In rinnovo' ? 'bg-amber-50 text-amber-700 border-amber-100' : 'bg-red-50 text-red-700 border-red-100'}`} data-id="element-2657">
                      {supplier.contractStatus}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-2658">
                    <button className="text-[13px] font-medium text-[#00B4D8] hover:text-[#0096b4] transition-colors" data-id="element-2659">
                      Dettagli
                    </button>
                  </td>
                </tr>)}
              {filteredSuppliers.length === 0 && <tr data-id="element-2660">
                  <td colSpan={6} className="px-6 py-8 text-center text-gray-500 text-[13px]" data-id="element-2661">
                    Nessun fornitore trovato con i filtri correnti.
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>

        {/* Mobile Cards */}
        <div className="md:hidden flex flex-col divide-y divide-gray-100" data-id="element-2662">
          {filteredSuppliers.map(supplier => <div key={supplier.id} className="p-4 flex flex-col gap-3" data-id="element-2663">
              <div className="flex justify-between items-start" data-id="element-2664">
                <div data-id="element-2665">
                  <p className="text-[13px] font-medium text-[#2a3a54]" data-id="element-2666">
                    {supplier.name}
                  </p>
                  <p className="text-[12px] text-gray-500" data-id="element-2667">
                    {supplier.type} • {supplier.servicesCount} servizi
                  </p>
                </div>
                <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-[10px] font-medium border ${supplier.contractStatus === 'Attivo' ? 'bg-emerald-50 text-emerald-700 border-emerald-100' : supplier.contractStatus === 'In rinnovo' ? 'bg-amber-50 text-amber-700 border-amber-100' : 'bg-red-50 text-red-700 border-red-100'}`} data-id="element-2668">
                  {supplier.contractStatus}
                </span>
              </div>
              <div className="flex justify-between items-center mt-1" data-id="element-2669">
                <span className="text-[13px] font-semibold text-[#1A202C]" data-id="element-2670">
                  €{supplier.monthlySpend.toLocaleString()}/mese
                </span>
                <button className="text-[12px] font-medium text-[#00B4D8]" data-id="element-2671">
                  Dettagli
                </button>
              </div>
            </div>)}
          {filteredSuppliers.length === 0 && <div className="p-8 text-center text-gray-500 text-[13px]" data-id="element-2672">
              Nessun fornitore trovato con i filtri correnti.
            </div>}
        </div>
      </div>
    </div>;
}